import { LazyCardGrid } from './LazyCardGrid';

export default LazyCardGrid;
